<ng-container *ngIf="mapAPIReady(); else mapNotLoaded">
    <div #map id="map" class="map relative">
        <div #mapContainer class="map">
        </div>

        <!-- Map controls. Inside #map and positioned against it, like the card,
             so both widgets sit in the same coordinate space and cannot drift
             into each other. Carries the same tl-card surface as the card. -->
        <div *ngIf="showMapToolbar"
             class="tl-map-toolbar tl-card absolute left-8 top-10 z-20 flex min-h-8 flex-row items-center justify-between gap-5 px-2.5 py-1.5 shadow-md">
            <mat-checkbox *ngIf="!hideInfoIcon && _isSingleTank === false"
                          [checked]="showMapClusters"
                          [disabled]="mapPanelIsClosed"
                          (change)="toggleShowMapClusters($event)">{{ 'General.ShowMapClusters' | translate }}</mat-checkbox>

            <!----------------------------------------------
                map region drawing controls
             ---------------------------------------------->
            <div class="flex flex-row items-center gap-2" *ngIf="useMapRegions">
                <!-- start drawing a new map region -->
                <i *ngIf="showCustomControls.draw == true"
                   class="fa-solid fa-xl fa-draw-polygon custom-button text-brand-blue"
                   (click)="onDrawClick()"
                   title="{{ 'TankMap.CustomControls.Draw' | translate }}">
                </i>
                <!-- Existing map region buttons -->
                <i *ngIf="showCustomControls.edit == true"
                   class="fa-solid fa-xl fa-pencil custom-button text-brand-blue"
                   (click)="onEditClick()"
                   title="{{ 'TankMap.CustomControls.Edit' | translate }}">
                </i>
                <i *ngIf="showCustomControls.apply == true"
                   class="fa-solid fa-xl fa-circle-check custom-button text-status-green"
                   (click)="onApplyClick()"
                   title="{{ 'TankMap.CustomControls.Apply' | translate }}">
                </i>
                <i *ngIf="showCustomControls.cancel == true"
                   class="fa-solid fa-xl fa-circle-xmark custom-button text-status-red"
                   (click)="onCancelClick()"
                   title="{{ 'TankMap.CustomControls.Cancel' | translate }}">
                </i>
                <i *ngIf="showCustomControls.delete == true"
                   class="fa-solid fa-xl fa-trash custom-button text-status-red"
                   (click)="onDeleteClick()"
                   title="{{ 'TankMap.CustomControls.Delete' | translate }}">
                </i>
                <!-- new map region buttons -->
                <i *ngIf="showCustomControls.applyNew == true"
                   class="fa-solid fa-xl fa-circle-check custom-button text-status-green"
                   (click)="onApplyNewClick()"
                   title="{{ 'TankMap.CustomControls.ApplyNew' | translate }}">
                </i>
                <i *ngIf="showCustomControls.cancelNew == true"
                   class="fa-solid fa-xl fa-circle-xmark custom-button text-status-red"
                   (click)="onCancelNewClick()"
                   title="{{ 'TankMap.CustomControls.CancelNew' | translate }}">
                </i>

                <span class="custom-text" *ngIf="showCustomControls.latLon == true">
                    {{ 'TankMap.CustomControls.LatLon' | translate }}: {{currentLatLon}}
                </span>
                <span class="custom-text" *ngIf="showCustomControls.radius == true">
                    {{ 'TankMap.CustomControls.Radius' | translate }}: {{currentRadius}}
                </span>
            </div>

            <svg-icon *ngIf="!hideInfoIcon" [src]="'assets/svg/info.svg'"></svg-icon>
        </div>

        <!-- Inside #map, not a google.maps.OverlayView: the card is screen-
             positioned, so it needs no projection and no per-frame draw(). It
             lives in #map (which is `relative`) rather than alongside it so it
             is contained by the map on every host - tank-map declares
             ViewEncapsulation.None, so its :host rule never matched and an
             absolutely positioned sibling escaped to the page instead.
             top-24 when the cluster toolbar is up, so the two do not overlap. -->
        <app-tank-map-card *ngIf="currentTankInfo"
                           class="tl-map-card-slot absolute bottom-4 left-4 z-10 flex w-96 min-w-72 max-w-full items-start"
                           [ngClass]="showMapToolbar ? 'top-24' : 'top-4'"
                           [tankInfo]="currentTankInfo"
                           [photos]="currentTankPhotos"
                           [volumePct]="volumePct"
                           [carouselIndex]="carouselIndex"
                           [carouselCount]="carouselCount"
                           (cardCloseClick)="onPopUpCloseClick()"
                           (nextCarouselMarker)="nextCarouselMarker()"
                           (prevCarouselMarker)="prevCarouselMarker()"></app-tank-map-card>
    </div>
</ng-container>
<ng-template #mapNotLoaded>
    <div class="mapNotLoaded" style="width: 100%;display: flex; place-content: space-around;position: relative;">
        <mat-spinner></mat-spinner>
    </div>
</ng-template>
